import Sprite from "./Sprite"

export default Sprite
